<template>
  <div
    class="consult-banner"
    role="status"
  >
    <i
      class="fas fa-lock"
      aria-hidden="true"
    />

    <span class="consult-banner__name">{{ promoterName || 'Outra promotora' }}</span>
    <span class="consult-banner__state">· {{ isPromoterBlocked ? blockedMessage : 'Somente consulta' }}</span>

    <button
      type="button"
      class="consult-banner__action"
      @click="$emit('switch')"
    >
      Trocar
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { BLOCKED_MESSAGE } from '@/utils/promoterAccess';

export default {
  name: 'PromoterConsultBanner',
  data: () => ({ blockedMessage: BLOCKED_MESSAGE }),
  computed: {
    ...mapGetters({
      isPromoterBlocked: 'user/isPromoterBlocked',
      promoterName: 'user/promoterName',
    }),
  },
};
</script>

<style lang="scss" scoped>
.consult-banner {
  display: flex;
  gap: 0.5rem;
  height: 100%;
  padding: 0 1rem;
  background-color: map.get($stone-types, "100");
  border-bottom: 1px solid map.get($stone-types, "200");

  align-items: center;

  i {
    color: map.get($stone-types, "500");
    font-size: 0.8125rem;
  }
}

.consult-banner__name {
  overflow: hidden;
  min-width: 0;

  flex: 0 1 auto;

  color: map.get($stone-types, "700");
  font-size: 0.8125rem;
  font-weight: 600;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.consult-banner__state {
  flex: none;

  color: map.get($stone-types, "500");
  font-size: 0.8125rem;
  white-space: nowrap;
}

.consult-banner__action {
  flex: none;
  margin-left: auto;
  padding: 0;
  border: 0;
  background-color: transparent;

  color: $blue-600;
  font-family: inherit;
  font-size: 0.8125rem;
  font-weight: 500;
  text-decoration: underline;
  white-space: nowrap;
  cursor: pointer;

  &:hover {
    color: $blue-700;
  }
}
</style>
